import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getEditedDays, getIntervals, getWeekSummary } from '../../../selectors/autobooking';
import AutoBooking from '../index';
import { checkPermisson, getLeagues } from '../../../selectors/common';
import { PERMISSIONS } from '../../../constants';
import { aAddInterval, aGetAutoBooking, aSaveChanges } from '../../../reducers';
import { aClearChanges, aDeleteInterval } from '../../../reducers/autobooking';

const mapToProps = (state) => ({
  leagues: getLeagues(state),
  weekSummary: getWeekSummary(state),
  intervals: getIntervals(state),
  editedDays: getEditedDays(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getIntervals: (payload) => dispatch(aGetAutoBooking(payload)),
  deleteInterval: (payload) => dispatch(aDeleteInterval(payload)),
  addNewInterval: (payload) => dispatch(aAddInterval(payload)),
  clearChanges: (payload) => dispatch(aClearChanges(payload)),
  saveChanges: (payload) => dispatch(aSaveChanges(payload)),
});

const SoccerAutoBooking = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    props.getIntervals();
    // eslint-disable-next-line
  }, []);

  return (
    <AutoBooking
      weekSummary={props.weekSummary}
      intervals={props.intervals}
      editedDays={props.editedDays}
      leagues={props.leagues}
      deleteInterval={props.deleteInterval}
      addNewInterval={props.addNewInterval}
      clearChanges={props.clearChanges}
      saveChanges={props.saveChanges}
      navigate={navigate}
      hasPermissionToUpdate={props.checkPermisson(PERMISSIONS.AUTOBOOKING_INTERVAL_UPDATE)}
    />
  );
};

export default connect(mapToProps, actionsToProps)(SoccerAutoBooking);

